import { render } from "./PIP.vue?vue&type=template&id=5ff7a0ab&scoped=true"
import script from "./PIP.vue?vue&type=script&lang=js"
export * from "./PIP.vue?vue&type=script&lang=js"

import "./PIP.vue?vue&type=style&index=0&id=5ff7a0ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff7a0ab"]])

export default __exports__